
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__event__/topic/[topic]",
      function () {
        return require("private-next-pages/__event__/topic/[topic].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__event__/topic/[topic]"])
      });
    }
  